import { Directive, Output, EventEmitter, OnInit, OnDestroy, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[inputChange]'
})
export class InputChangeDirective implements OnInit, OnDestroy {
  @Output() inputChange: EventEmitter<string> = new EventEmitter<string>();

  private valueSubscription: Subscription;
  private lastValue: string;

  constructor(@Self() private ngControl: NgControl) {
    this.lastValue = '';
  }

  ngOnInit(): void {
    this.valueSubscription = this.ngControl.valueChanges.subscribe((value: string) => {
      value = value || '';
      if(value != this.lastValue) {
        this.lastValue = value
        this.inputChange.emit(value);
      }
    });
  }

  ngOnDestroy(): void {
    this.valueSubscription?.unsubscribe();
  }
}